module.exports = __webpack_public_path__ + "static/media/ncl_containers.2d4068bf.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/images/cases/ncl_containers.mp4
// module id = 382
// module chunks = 0